import { ACTION_TYPES } from 'src/constants';

export function requestCheckoutDetail(payload) {
  return {
    type: ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_REQUEST,
    payload,
  };
}

export function requestCheckoutDetailSuccess(payload) {
  return {
    type: ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_SUCCESS,
    payload,
  };
}

export function requestCheckoutFailure(payload) {
  return {
    type: ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_FAILED,
    payload,
  };
}


export function requestGenerateCheckoutPayment(payload) {
  return {
    type: ACTION_TYPES.REQUEST_GENERATE_CHECKOUT_PAYMENT,
    payload,
  };
}

export function generateCheckoutPaymentSuccess(payload) {
  return {
    type: ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SUCCESS,
    payload,
  };
}

export function generateCheckoutPaymentFailure(payload) {
  return {
    type: ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_FAILED,
    payload,
  };
}


export function requestGenerateCheckoutPaymentSip(payload) {
  return {
    type: ACTION_TYPES.REQUEST_GENERATE_CHECKOUT_PAYMENT_SIP,
    payload,
  };
}

export function generateCheckoutPaymentSipSuccess(payload) {
  return {
    type: ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SIP_SUCCESS,
    payload,
  };
}

export function generateCheckoutPaymentSipFailure(payload) {
  return {
    type: ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SIP_FAILED,
    payload,
  };
}
